import React from "react";
import { Modal } from "antd";
import {
  RightOutlined,
  StarOutlined,
  BuildOutlined,
  CommentOutlined,
  BulbOutlined,
  CheckOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { CreateContentMenu } from "./style";

const CHALLENGE_OPTIONS = [
  {
    key: "ai-challenge",
    title: "AI-assisted creation",
    subtitle: "Generate a full challenge with AI",
    path: "/AiChallenge",
    icon: StarOutlined,
    iconTone: "purple",
  },
  {
    key: "challenge",
    title: "Build from scratch",
    subtitle: "Create a challenge manually",
    path: "/CreateChallenge",
    icon: BuildOutlined,
    iconTone: "green",
  },
];

const NUDGE_OPTIONS = [
  {
    key: "prompt",
    title: "Reflection",
    path: "/CreatePrompt",
    icon: CommentOutlined,
  },
  {
    key: "quote",
    title: "Insight",
    path: "/CreateQuote",
    icon: BulbOutlined,
  },
  {
    key: "action",
    title: "Action",
    path: "/CreateAction",
    icon: CheckOutlined,
  },
  {
    key: "practice",
    title: "Practice",
    path: "/CreatePractice",
    icon: SyncOutlined,
  },
];

function ContentOption({ icon: Icon, iconTone, title, subtitle, onClick, large }) {
  return (
    <button type="button" className="create-content-option" onClick={onClick}>
      <span
        className={`create-content-option-icon${
          iconTone ? ` create-content-option-icon--${iconTone}` : ""
        }${large ? " create-content-option-icon--large" : ""}`}
      >
        <Icon />
      </span>
      <span className="create-content-option-body">
        <span className="create-content-option-title">{title}</span>
        {subtitle && (
          <span className="create-content-option-subtitle">{subtitle}</span>
        )}
      </span>
      <RightOutlined className="create-content-option-arrow" />
    </button>
  );
}

export default function CreateContentModal({ open, onClose, navigate }) {
  const handleSelect = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <Modal
      title="Create new content"
      open={open}
      onCancel={onClose}
      footer={null}
      width={480}
      className="create-content-modal"
      destroyOnClose
    >
      <CreateContentMenu>
        <div className="create-content-section">
          <div className="create-content-section-label">Challenge</div>
          <div className="create-content-challenge-list">
            {CHALLENGE_OPTIONS.map((option) => (
              <ContentOption
                key={option.key}
                icon={option.icon}
                iconTone={option.iconTone}
                title={option.title}
                subtitle={option.subtitle}
                large
                onClick={() => handleSelect(option.path)}
              />
            ))}
          </div>
        </div>

        <div className="create-content-section">
          <div className="create-content-section-label">Nudge</div>
          <div className="create-content-nudge-list">
            {NUDGE_OPTIONS.map((option) => (
              <ContentOption
                key={option.key}
                icon={option.icon}
                title={option.title}
                onClick={() => handleSelect(option.path)}
              />
            ))}
          </div>
        </div>
      </CreateContentMenu>
    </Modal>
  );
}
